// loader.tsx
import TruckLoader from "./TruckLoader";
import "./loader.css";
import React, { createContext, useContext, useState } from 'react';

// Define LoaderContextType interface
export interface LoaderContextType {
  show: () => void;
  hide: () => void;
}

// Export LoaderContextType
export const LoaderContext = createContext<LoaderContextType>({ show: () => {}, hide: () => {} });

// LoaderProvider component
export const LoaderProvider = ({ children }: { children: React.ReactNode }) => {
  const [showLoader, setShowLoader] = useState(false);

  const show = () => setShowLoader(true);
  const hide = () => setShowLoader(false);

  return (
    <LoaderContext.Provider value={{ show, hide }}>
      {children}
      {showLoader  && (
        <div id="global_loader" className="glb-ldr-prt !bg-white/10 backdrop-blur-md ">
          <div className="gl-ldr-ctr">
          <TruckLoader></TruckLoader>
            {/* <div className="gl-loader"></div> */}
          </div>
        </div>

      )}
    </LoaderContext.Provider>
  );
};

// useLoader hook
export const useLoader = () => useContext(LoaderContext);
